module.exports = __webpack_public_path__ + "static/img/public_shield.557ec47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/public_shield.png
// module id = M9PX
// module chunks = 52